// extracted by mini-css-extract-plugin
module.exports = {"modalState":"ModalState_modalState__2ICJR","btnClose":"ModalState_btnClose__24tAY","imgCont":"ModalState_imgCont__1msJn","content":"ModalState_content___HMtf"};